import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DefaultPage from "./default-page.jsx";

export default function Calendar() {
  var data = [
    {
      title: "Spanferkelessen im Bonschab",
      date: "21. März 2026",
      description:
        "Genießen Sie mit uns ein traditionelles Spanferkelessen im Bonschab. Ein geselliger Abend mit gutem Essen und netten Gesprächen erwartet Sie.",
    },
    {
      title: "Radltour",
      date: "14. Mai 2026",
      description:
        "Bei unserer Radltour erkunden wir die schöne Umgebung und genießen die Natur. Eine entspannte Tour für alle, die gerne gemeinsam in die Pedale treten.",
    },
    {
      title: "Sommerfest",
      date: "20. Juni 2026",
      description:
        "Unser Sommerfest ist der Höhepunkt des Jahres. Mit Musik, gutem Essen und bester Stimmung feiern wir gemeinsam den Sommer. Alle Mitglieder, Freunde und Familien sind herzlich willkommen.",
    },
    {
      title: "SGI Vollversammlung",
      date: "19. Dezember 2026",
      description:
        "Die jährliche Vollversammlung der SGI. Hier besprechen wir das vergangene Jahr, planen zukünftige Aktivitäten und genießen das Zusammensein bei einem gemütlichen Abendessen.",
    }
  ];
  return (
    <DefaultPage>
      <Typography variant="h3" align="center">
        Kalender
      </Typography>
      <br />
      {data.map((event) => (
        <div>
          <Box align="center">
            <Typography
              variant="h5"
              align="center"
              sx={{ paddingInline: "5%" }}
            >
              {event.date} - {event.title}
            </Typography>
            <Typography
              variant="body1"
              align="center"
              sx={{ paddingInline: "5%" }}
            >
              {event.description}
            </Typography>
          </Box>
          <br />
        </div>
      ))}
      <br />
      <Typography variant="body1" align="center">
        Bei Fragen oder Anmeldungen zur Teilnahme an den Veranstaltungen
        verwenden Sie gerne unser Kontaktformular.
      </Typography>
    </DefaultPage>
  );
}
